<template>
  <el-form-item
    ref="rangeDate"
    :prop="prop"
    :label="label"
    :required="required"
  >
    <el-form
      :inline="true"
      :model="form"
    >
      <el-form-item
        ref="rangeDateInner"
        prop="rangeDateInner"
        :rules="rules"
      >
        <el-date-picker
          v-model="rangeDate"
          type="daterange"
          format="yyyy/MM/dd"
          value-format="yyyy/MM/dd"
          :range-separator="rangeSeparator"
          :start-placeholder="startPlaceholder"
          :end-placeholder="endPlaceholder"
          :disabled="disabled"
          :autofocus="autofocus"
        />
      </el-form-item>
    </el-form>
  </el-form-item>
</template>

<script>
import Validator from '@/mixins/Validator.vue'

export default {
  components: {
  },
  mixins: [
    Validator
  ],
  props: {
    label: String,
    prop: {
      type: String,
      default: 'date_range'
    },
    dateFrom: String,
    dateTo: String,
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    rangeSeparator: {
      type: String,
      default: '～'
    },
    startPlaceholder: {
      type: String,
      default: 'yyyy/MM/dd'
    },
    endPlaceholder: {
      type: String,
      default: 'yyyy/MM/dd'
    },
    searchCond: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      form: {
        rangeDateInner: [
          this.dateFrom,
          this.dateTo
        ]
      }
    }
  },
  computed: {
    rangeDate: {
      get () {
        if ((typeof this.dateFrom !== 'undefined') && (typeof this.dateTo !== 'undefined')) {
          if ((this.dateFrom !== '') && (this.dateTo !== '')) {
            this.$set(this.form, 'rangeDateInner', ['' + this.dateFrom, '' + this.dateTo])
          }
        }
        return ['' + this.dateFrom, '' + this.dateTo]
      },
      set (rangeDate) {
        this.$set(this.form, 'rangeDateInner', rangeDate)
        var dateFrom = ''
        var dateTo = ''
        if (rangeDate) {
          [dateFrom, dateTo] = rangeDate
        }
        this.$emit('update:dateFrom', dateFrom)
        this.$nextTick(() => {
          this.$emit('update:dateTo', dateTo)
        })
      }
    },
    rules: {
      get () {
        const rules = []
        if (!this.disabled) {
          if (this.required) {
            rules.push(this.validatorRangeRequired(this.label, 'blur'))
          }
        }
        return rules
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      const form = this.$el.querySelector('.el-form')
      const div = document.createElement('div')
      const formItem = form.firstChild
      div.appendChild(formItem)
      form.parentNode.appendChild(div)
      form.remove()
      const rangeInputArray = formItem.querySelectorAll('.el-range-input')
      rangeInputArray.forEach((x) => {
        x.setAttribute('maxlength', '10')
      })
      this.$refs.rangeDate.validate = this.$refs.rangeDateInner.validate
      this.$refs.rangeDate.clearValidate = this.$refs.rangeDateInner.clearValidate
      this.$refs.rangeDate.resetField = this.$refs.rangeDateInner.resetField
    })
  },
  methods: {
  }
}
</script>

<style lang="scss">
</style>
